import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { SkeletonContainer } from "../../Loader/Loader.jsx";
import { useCommon } from "../../../Hooks/Common/useCommon.js";
import { useOutpasslist } from "../../../Hooks/Features/Gatepass/useOutpasslist.js";
import nodata from '../../../assets/nodata.jpg';
import { dateConvert } from "../../../utils/Helper.js";

export const OutpassList = ({ filterValues }) => {
  const { checkPermission } = useCommon();
  const { tagRef, loader, tabsList, handleUpsertGatepassRequest } = useOutpasslist({ filterValues });

  return (
    <div ref={() => checkPermission(("OutpassList", tagRef))} style={{ height: "100%" }}>
      <div ref={tagRef} id='{"tabname": "gate_pass", "data": "gatepass_outpasslist_tab"}' style={{ height: "100%" }}>
        {loader ? (
          <div style={{ height: "100%" }}>
            <SkeletonContainer />
          </div>
        ) : tabsList.length !== 0 ? (
          <div className="outpass-list">
            {tabsList.map((item) => (
              <div key={item?.employee_id} className="rounded p-2 d-flex align-items-center gap-2" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }}>
                <div className="w10">
                  <img src={item?.image_url} alt="" width={35} height={35} className="rounded-circle me-1" onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                </div>
                <div className="w85">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="fw-bold">{item?.user_display_name}</div>
                    <div><span className="fw-bold">Out Time: </span>{item?.user_out_datetime && dateConvert(item?.user_out_datetime, "time")}</div>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <div className="w65">
                      <div>{item?.employee_id} | {item?.apply_datetime && dateConvert(item?.apply_datetime, "date-time-months")}</div>
                      <div className="text-truncate c-default w100" title={item?.leave_reason}>{item?.leave_reason}</div>
                    </div>
                    <div className=" d-flex gap-2">
                      <div className="d-flex justify-content-center align-items-center c-pointer bg-success" style={{ width: "30px", height: "30px", borderRadius: "50%" }}>
                        <FontAwesomeIcon className="text-white" icon="fa-solid fa-thumbs-up" onClick={() => handleUpsertGatepassRequest(item, 'is_approved')} />
                      </div>
                      <div className="d-flex justify-content-center align-items-center c-pointer bg-danger" style={{ width: "30px", height: "30px", borderRadius: "50%" }}>
                        <FontAwesomeIcon className="text-white" icon="fa-solid fa-thumbs-down" onClick={() => handleUpsertGatepassRequest(item, 'is_rejected')} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='text-center'>
            <img src={nodata} alt="data not found" />
            <p className='text-center red mt-3'> Data Not Found</p>
          </div>
        )
        }
      </div>
    </div>
  )
};

export default OutpassList;
